import { render, staticRenderFns } from "./HomepageCard.vue?vue&type=template&id=ab1a05a6&scoped=true&"
import script from "./HomepageCard.vue?vue&type=script&lang=js&"
export * from "./HomepageCard.vue?vue&type=script&lang=js&"
import style0 from "./HomepageCard.vue?vue&type=style&index=0&id=ab1a05a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1a05a6",
  null
  
)

export default component.exports